import { render, staticRenderFns } from "./DateIOSPicker.vue?vue&type=template&id=10a3dbf6&scoped=true&"
import script from "./DateIOSPicker.vue?vue&type=script&lang=js&"
export * from "./DateIOSPicker.vue?vue&type=script&lang=js&"
import style0 from "./DateIOSPicker.vue?vue&type=style&index=0&id=10a3dbf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a3dbf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMessages } from 'vuetify/lib/components/VMessages';
installComponents(component, {VMessages})
